import { ThemeService } from "@aecom/core";
import { Component, HostListener, OnInit, inject } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { PreviousRouteService } from "./services/previousRoute.service";
import environment from "src/environments/environment";
import { AuthService } from "@bbj/components";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: false
})
export default class AppComponent implements OnInit {
  themeService = inject(ThemeService);
  private router = inject(Router);
  private urlService = inject(PreviousRouteService);
  authService = inject(AuthService);

  mainheight: number;

  previousUrl: string = null;

  currentUrl: string = null;

  isIframe = false;

  @HostListener("window:resize")
  onResize(): void {
    this.mainheight = window.innerHeight;
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.authService.initService(environment.stage, environment.azureNew.tenantId);
    this.mainheight = window.innerHeight;
    // this.themeService.setActiveFullTheme("dark");
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        console.log("PreviousUrl:", this.previousUrl);
        console.log("currentUrl:", this.currentUrl);
        this.urlService.setPreviousUrl(this.previousUrl);
      });
  }
}
